export default __webpack_public_path__ + "static/media/History.f175bf6c.svg";